import { BaseModel } from '../core/abstractions/base.model';
import { DashboardConfigurationModel } from './dashboard-configuration.model';

export class LayoutSettingsModel extends BaseModel {
    dashboard: DashboardConfigurationModel = { cards: [] };
    isNavigationCollapsed = false;

    constructor(init?: Partial<LayoutSettingsModel>) {
        super();
        Object.assign(this, init);
    }
}
